export const PhoneAnalyticsQueryKeys = {
  base: ['phoneAnalytics'] as const,

  callResults: (query?: string) => [...PhoneAnalyticsQueryKeys.base, 'callResults', query],
  filterOptions: () => [...PhoneAnalyticsQueryKeys.base, 'filterOptions'],
  report: (query?: string) => [...PhoneAnalyticsQueryKeys.base, 'report', query],
  snapshotReport: (query?: string) => [...PhoneAnalyticsQueryKeys.base, 'snapshotReport', query],
};
